import { render } from "./ButtonBurger.vue?vue&type=template&id=46e4b784"
import script from "./ButtonBurger.vue?vue&type=script&lang=js"
export * from "./ButtonBurger.vue?vue&type=script&lang=js"

import "./ButtonBurger.vue?vue&type=style&index=0&id=46e4b784&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__